import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-repair-awaiting-modal',
  templateUrl: './repair-awaiting-modal.component.html',
  styleUrls: ['./repair-awaiting-modal.component.scss'],
})
export class RepairAwaitingModalComponent {
  constructor(
    protected dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RepairAwaitingModalComponent>,
    private api: OrderApiService,
    private message: MessageService,
    private router: Router
  ) {}

  loading = false;
  async onOk() {
    try {
      this.loading = true;
      const r = await this.api.changeYoutubeGroup(this.data.id);
      if (r.status === 0) {
        this.message.open('提交成功');
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            this.router.navigate(['/user/profile/seats']);
          });
      } else {
        this.message.warn('提交失败');
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
